import api from "./axiosInstance";

/**
 * @param {number} limit
 * @param {number} offset
 */
export const getVouchers = async (limit = 10, offset = 0) => {
  const response = await api.get(
    `api/v1/vouchers/?limit=${limit}&offset=${offset}`
  );
  return response.data;
};


export const getVouchersByEvent = async (limit = 10, offset = 0, eventId) => {
  const response = await api.get(
    `api/v1/vouchers/?event=${eventId}&limit=${limit}&offset=${offset}`
  );
  return response.data;
};

export const createVoucher = async (payload) => {
  const response = await api.post(
    "api/v1/vouchers/",
    payload
  );
  return response.data;
};

export const updateVoucher = async (voucherId, payload) => {
  const response = await api.patch(
    `api/v1/vouchers/${voucherId}/`,
    payload
  );
  return response.data;
};


export const deleteVoucher = async (voucherId) => {
  await api.delete(`api/v1/vouchers/${voucherId}/`);
};

